import React, { useState } from 'react';
import { 
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Typography
} from '@mui/material';
import API from '../config/axiosConfig';
import { primaryButtonStyle, secondaryButtonStyle, dialogActionsStyle } from '../utils/sharedStyles';
import InputWithIcon from './InputWithIcon';
import passwordIcon from '../assets/users/password.svg';


const ChangePasswordDialog = ({ open, onClose, userId }) => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');

  const handlePasswordChange = async () => {
    if (newPassword && newPassword.length < 6) {
      setPasswordError('סיסמה צריכה להכיל מינימום 6 תוים');
      return;
    }
    else if (newPassword !== confirmPassword) {
      setPasswordError('הסיסמאות אינן תואמות');
      return;
    }
    try {
      await API.post(`/api/users/${userId}/set-password`, { newPassword });
      setNewPassword('');
      setConfirmPassword('');
      setPasswordError('');
      onClose();
    } catch (error) {
      console.error('Password change failed:', error);
      setPasswordError('שינוי הסיסמה נכשל');
    }
  };

  const onCloseClicked = async () => {
    setNewPassword('');
    setConfirmPassword('');
    setPasswordError('');
    onClose();
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      PaperProps={{
        style: {
          borderRadius: '8px',
          padding: '16px',
        },
      }}
    >
      <DialogTitle style={{ textAlign: 'center', fontWeight: 'bold', color: '#103C6E' }}>
        שינוי סיסמה
      </DialogTitle>
      <DialogContent>
        <InputWithIcon
          icon={passwordIcon}
          placeholder="הזן סיסמה"
          type="password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          autoFocus
        />
        <InputWithIcon
          style={{marginTop: '20px'}}
          icon={passwordIcon}
          placeholder="חזור שנית על הסיסמה"
          type="password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
        />
        {passwordError && <Typography color="error">{passwordError}</Typography>}
      </DialogContent>
      <DialogActions style={dialogActionsStyle}>
        <Button 
          onClick={onCloseClicked}
          style={secondaryButtonStyle}
        >
          ביטול
        </Button>
        <Button 
          onClick={handlePasswordChange} 
          style={primaryButtonStyle}
        >
          שמור
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChangePasswordDialog;